/**
 * Created by Marcus Zhao on 7/2/19.
 * Description:
 *
 * ------ maintenance history ------
 * 05/14/2019 Marcus add logic for append Entity to membership.
 * 07/5/2019  Marcus Zhao - Team and user configList are loaded separately
 * 07/25/2019 Marcus Zhao - Use smartAction for CreateEntityAllSuccess
 * 08/21/2019 Marcus Zhao - Add 'action' in preSave() function for judge the note action  .
 * 09/20/2019 Marcus Zhao - Add  changePrivateStatus() function for judge add the current user.
 * 09/23/2019 Marcus Zhao - Move the postSave() to templateService and use templateService.relationshipSaveAction();
 * 02/13/2020 Marcus Zhao - Add _startEntity for valid entity control change.(TAM-28175)
 * 08/31/2021 Marcus Zhao - Add WebAddress for create and edit entity remove old address in html.
 * 08/02/2022 Alex Xia - Add the feature of on the fly for office add-in
 */
import { Component, OnInit, ViewChild, HostListener, OnDestroy, Input, ViewContainerRef, Renderer2, ElementRef } from '@angular/core';
import { TabOptions, TabItem } from '../../widgets/tabs/tabs.model';
import { Subscription, Subject, ReplaySubject, of as observableOf } from 'rxjs';
import { EntityDialogOpenOptions, EntityDialogType, EntityBack, EntityEditStatusActionType, EntityAddressType } from './entity-dialog.model';
import { EntityDialogService } from './entity-dialog.service';
import { DualListConfig } from '../../widgets/dual-list/dual-list.config';
import { DualListItem } from '../../widgets/dual-list/dual-list.component';
import { TemplateDialogService } from '../template/template-dialog.service';
import { Entity } from '@tamalelibs/models/entity.model';
import { CorpOfficer } from '@tamalelibs/models/corp-officer.mode';
import { catchError, filter, map, take, } from 'rxjs/operators';
import { EntityType } from '@tamalelibs/models/entity-type.model';
import { Contact } from '@tamalelibs/models/contact.model';
import { CorporateDetail } from '@tamalelibs/models/corporate-detail.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { WebLink } from '@tamalelibs/models/web-link.model';

import { lastCustomActionSelector } from '../../redux/reducers/action-history.reducer';
import { CREATE_ENTITY_SUCCESS, CREATE_ENTITY_FAILURE, EDIT_ENTITY_SUCCESS, EDIT_ENTITY_FAILURE, CREATE_ENTITY_ALL_SUCCESS, EDIT_ENTITY_ALL_SUCCESS } from '@tamalelibs/redux/entity.actions';
import { ToastService } from '../../widgets/toast/toast.service';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { Store, select, createSelector } from '@ngrx/store';
import { defaultEntityTypeSelector, availableEntityTypeSelector } from '../../redux/reducers/entity-type.reducer';
import { TemplateService } from '@tamalelibs/services/template.service';
import { EntityService } from '@tamalelibs/services/entity.service';
import { TamUploadConfig } from '../../widgets/tam-upload/tam-upload.model';
import { NoteEntry } from '@tamalelibs/models/note-entry.model';
import { EntryService } from '@tamalelibs/services/entry.service';
import { CREATE_NOTE_SUCCESS, CREATE_NOTE_FAILURE } from '@tamalelibs/redux/note.actions';
import { NoteActions, ComponentTypes, EntityActions } from '@tamalelibs/constants/business.constants';
import { DialogService } from '@progress/kendo-angular-dialog';
import * as _lodash from 'lodash';
import { SystemUser } from '@tamalelibs/models/user.model';
import { StoreQuerierService } from '../../services/store-querier.service';
import { AppState } from '../../redux';
import { UntypedFormControl } from '@angular/forms';
import { OpenDynamicComponentService } from '../../pages/home/home-open-dynamic-component';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { EntityViewModelForWeb } from './entity-view-web.model';
import { CreateNoteSuccess, CreateEntityAllSuccess, EditEntityAllSuccess, CreateRelationShipSuccess, CreateRelationShipFailed } from '../../redux/actions/template-web.actions';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { DialogAction } from '../../widgets/tam-dialog/tam-dialog.model';
import { RelationshipTreeService } from '../../services/relationship-tree.service';
import { RelationshipTreeActions } from '../relationship-tree/relationship-tree.view-model';
import { businessConstants } from '@tamalelibs/constants/business.constants';
import { businessConstants as webBusinessConstants } from '../../constants/business.constants';
import { CREATE_RELATIONSHIP_SUCCESS, CREATE_RELATIONSHIP_FAILURE } from '@tamalelibs/redux/template.actions';
import { MessageService } from '../../services/message.service';
import { MessageType } from '@tamalelibs/models/message.model';
import { AddressDetail } from '@tamalelibs/models/job-function';
import { TeamsActionTypes } from '../../redux/actions/teams.actions';
import { NoteDialogOpenOptions } from '../note-dialog/note-dialog.model';
import { AddInUtilities } from '../../services/utilities/addin-utilities';
import { RelationshipService } from '@tamalelibs/services/relationship.service';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'entity-dialog',
    templateUrl: './entity-dialog.component.html',
    styleUrls: ['./entity-dialog.component.scss'],
    providers: [WebTemplateViewModel, DialogService],
    standalone: false
})
export class EntityDialogComponent implements OnInit, OnDestroy {
    constructor(
        private _element: ElementRef,
        private _entityDialogService: EntityDialogService,
        private _templateDialogService: TemplateDialogService,
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _entityViewModel: EntityViewModelForWeb,
        private _alertWindow: AlertWindowService,
        private _toast: ToastService,
        private _relationshipService: RelationshipService,
        private _templateService: TemplateService,
        private _store: Store<any>,
        private _storeQuerierService: StoreQuerierService,
        private _relationshipTreeService: RelationshipTreeService,
        private _entryService: EntryService,
        private _entityService: EntityService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _messageService: MessageService,
        private _renderer: Renderer2,
    ) {
        this._el = this._element.nativeElement;
        this.currentUser = this._storeQuerierService.getCurrentUser();
        if (this.currentUser?.credential) {
            this._isAdminUser = this.currentUser.credential.admin;
            this._isAccessList = this.currentUser.credential.updateEntityAccessList;
            this._isIncludeTeam = this.currentUser.credential.manageTeam;
            this._isPublicToPrivateEntity = this.currentUser.credential.pubToPrivEntityConversion;
        }
    }

    @ViewChild('dualList', { static: false }) dualListInst;
    @Input() id;
    addButtonStatus: boolean;
    allowCustom = false;
    address: AddressDetail = new AddressDetail();
    aliasArray: string[] = [];
    age: string;
    checkbox = false;
    canSaveAsDraft = false;
    corporateDetail: CorporateDetail;
    corpOfficer: CorpOfficer;
    contact: Contact; // contact model
    currentUser: SystemUser;
    dialogWidth = 700;
    dialogOpenOptions: EntityDialogOpenOptions;
    entry: NoteEntry;
    entityTypes: Array<EntityType> = []; // save the entity type dropdown data set
    entityTypesResource: Array<EntityType> = []; // save the entity type dropdown data
    entityTypeDefault: EntityType; // set the default entity type;
    entityTypeCurrent: EntityType;
    entityTypeDisabled = false;
    // for alias item length
    errorMessages = {
        'errormessage': 'Alias name can not have more than 128 characters',
    };

    duallistConfig: DualListConfig;
    dualListTeamConfig: DualListConfig;
    dualListUserAndTeamConfig: DualListConfig;
    duallistDataSource: Array<any>;
    entity: Entity;
    isShow = false;
    isNeedReload: boolean;
    isPrivate = false;
    isDisabled = false;
    isProgressing = false;
    isDialogClosedForPlugin = 10; // 10 stands for open;20 stands for closed
    isOfficeAddinMode = false;
    name: string;
    noEntityType = false;
    opened: boolean;
    officers: Array<CorpOfficer>;
    position: string;
    tabNumber = 3;
    tabsOptions: TabOptions;
    titleName: string;
    uploadConfig: TamUploadConfig;
    uploadEditing = 0;
    viewContainer: ViewContainerRef;
    valueChangeSubject: Subject<any>; // for notifying other control about value set change
    valueChangeSubscribtion: Subscription;
    // for alias item length validation
    validators = [this._validateAliasLength];
    weblinkName: string;
    weblinkUrl: string;

    private _addToMemberShip = [];
    // data models
    private _currentEntity: any;
    private _configurationData: any;
    private _destroySubscriptions: Array<Subscription> = [];
    private _disableEntityField = false; // mark if the entities field should be disabled, disable entities field in create sidnote mode when parent note is note editable
    private _el: HTMLElement;
    private _entityName: string;
    private _editingEntryId: string; // the entryId that is being edited, get this from routing URL
    private _entityId;
    private _findFirstControl = false; // TAM-32009
    private _firstOpen = true; // mark if the window is opened for the first time, no matter create or edit
    private _hasEntry = false; // confirm create or edit entity  request all done
    private _infoToast: NotificationOptions = {
        message: 'Saved to Note',
        style: NotificationStyles.Info
    };
    private _isPreNoteEntryForm = false; // mark the last noteType for switching notetype logic
    private _isAccessList: boolean;
    private _isAdminUser = false;
    private _isIncludeTeam: boolean;
    private _isPublicToPrivateEntity: boolean;
    private _isEntitySuccess: boolean;
    private _isIncludeSaveActions: boolean;
    private _noteTypeId: string; // save the selected note type ID
    private _notifyAction = null;

    private _noteAction: string; // addNote, editNote, addSidenote, editSidenote, get this from routing URL
    private _hasAppendToMembership = false;
    private _opensubscription: Subscription;
    private _previousTemplateValueSet: any = {}; // mark the previous template value set when switching note types, based on adhocId
    private _previousEntityType: EntityType;
    private _specialCommonentTypes = [ComponentTypes.checkbox, ComponentTypes.label, '']; // TAM-32009
    private _startEntity: Entity; // for validate the contact change
    private _startDuallistConfig;
    private _tplConfig = [];
    private _templateValueSet: any = {}; // mark the template control's values, based on controlId

    private _widthFactor = 1.2; // Calculate the Size Ratio

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (this.opened) {
            $event.returnValue = true;
        }
    }

    ngOnInit() {
        this._initDefaultSubscribe();
        this._initPrivacy();
        this._opensubscription = this._entityDialogService.dialogOpen$.pipe(
            filter(action => !this.opened),
        ).subscribe((dialogOpenOptions: EntityDialogOpenOptions) => {
            if (this.id === dialogOpenOptions.instanceId) {
                this.dialogOpenOptions = dialogOpenOptions;
                if (dialogOpenOptions.openType) {
                    this.titleName = dialogOpenOptions.openType;
                    this._entityName = dialogOpenOptions.searchValue;
                    this._initData();
                    this._initSubscribe();
                    this._initOfficeAddIn(dialogOpenOptions);
                    this._onTheFlyEntityType(dialogOpenOptions);
                    if (dialogOpenOptions.openType === EntityDialogType.EditEntity) {
                        this._entityId = dialogOpenOptions.entityId;
                        this.isDisabled = true;
                        this.editEntityInitialization(dialogOpenOptions.openTab);
                    }
                }
            }
        });
        this.address = new AddressDetail();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => {
            if (!subscription.closed) {
                subscription.unsubscribe();
            }
        });
        this._opensubscription.unsubscribe();
    }

    /**
  *  user click the cancel/click  button
  *  status : tip alertWindow or close  or others
  */
    clickClose(status: string, event: Event) {
        this.entity.isPublic = !this.isPrivate;
        this._formatAliases();
        const contactIsEqual = _lodash.isEqual(this.entity, this._startEntity);
        const duallistConfigIsEqual = _lodash.isEqual(this._startDuallistConfig, this.duallistConfig);
        if (!this._templateDialogService.changeValueStatus && contactIsEqual && duallistConfigIsEqual) {
            this.opened = false;
            this._setDialogCloseForPlugin();
            this._clearData();
            this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
        } else {
            const subscription = this._alertWindow.warn('You have unsaved changes', ['Are you sure you want to discard all your changes?'], 'Discard', 'Go Back', this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    if (result) {
                        this.opened = false;
                        this._setDialogCloseForPlugin();
                        this._clearData();
                        this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
                    }
                    subscription.unsubscribe();
                });
        }
        if (event) {
            event.stopImmediatePropagation();
        }
    }

    clickAddOfficers() {
        const newOfficer = new CorpOfficer(this.name, this.age);
        newOfficer.position = this.position;
        newOfficer.age = this.age;
        newOfficer.name = this.name;
        this.entity.detail.officers.push(newOfficer);
        this.name = '';
        this.age = '';
        this.position = '';

    }

    clickAddWebLinks() {
        const weblink = new WebLink();
        weblink.title = this.weblinkName;
        weblink.url = this.weblinkUrl;
        if (!this.entity.webLinks) {
            this.entity.webLinks = new Array<WebLink>();
        }
        this.entity.webLinks.push(weblink);
        this.weblinkName = '';
        this.weblinkUrl = '';
    }

    clickAddAddress() {
        const otherAddress = new AddressDetail();
        otherAddress.name = EntityAddressType.Other;
        this.entity.webAddress.push(otherAddress);
    }

    /**
     * for judge the private list check status
     * @param value
     */
    changePrivateStatus(value) {
        if (value) {
            this.dualListUserAndTeamConfig.dataSource.map(item => {
                if (item.data.id === this.currentUser.id) {
                    return item.direction = 'right';
                }
            });
        }
    }

    editEntityInitialization(openTab) {
        this._entityService.getEntityDetail(this._entityId).pipe(
        ).subscribe(response => {
            this.entity = Entity.parse(response);
            this.entityTypeDefault = this.entityTypeCurrent = this.entity.type;
            // this.entityTypes.push(this.entityTypeDefault);
            this.aliasArray = this.entity.aliases;
            // set webAddress if no-exsit
            if (!this.entity.webAddress) {
                this.entity.webAddress = new Array<AddressDetail>();
                this.entity.webAddress[0] = new AddressDetail();
                this.entity.webAddress[0].name = EntityAddressType.Primary;
            }
            if (!this._isAdminUser) {
                this.entityTypeDisabled = true;
            }
            if (!this.entity.aliases || this.entity.aliases === null) {
                this.entity.aliases = new Array<string>();
            }
            this._startEntity = _lodash.cloneDeep(this.entity);
            this._noteTypeChanged(this.entityTypeDefault, openTab);
            // add static value for dynamic control
            this._noteTemplatePageViewModel.entityTemplateConfiguration(this.dialogOpenOptions.instanceId.toString())
                .pipe(
                    filter(res => res != null && res.contains != null),
                ).subscribe(res => {
                    this._processNoteTemplateConfiguration(res);
                });
            this._initMembers();
        });
    }

    // the keydown event should not be propagated to parent window
    @HostListener('keydown', ['$event'])
    handleKeydown(event: KeyboardEvent) {
        event.stopPropagation();
    }

    keySend(event) {
        if (event.ctrlKey && event.keyCode === 13) {
            // this.publish();
        }
    }

    onClickRemoveOfficer(currentItem) {
        this.entity.detail.officers = this.entity.detail.officers.filter(item => item !== currentItem);
    }

    onClickRemoveLinks(currentItem) {
        this.entity.webLinks = this.entity.webLinks.filter(item => item !== currentItem);
    }

    onClickRemoveAddress(currentItem) {
        this.entity.webAddress = this.entity.webAddress.filter(item => item !== currentItem);
    }

    onClickSetEventValue(e: Event) {
        if (this.dialogOpenOptions && this.dialogOpenOptions.eventKey) {
            e[this.dialogOpenOptions.eventKey] = this.dialogOpenOptions.eventValue;
        }
    }

    onContainerEvent(event) {
        this.viewContainer = event;
    }

    /**
      * dialog open
      */
    open() {
        this.opened = true;
    }

    onCancelBtnClick($event) {
        this.clickClose('1', null);
        // to solve the issue that the side sheet will be closed when clicking the close/cancel button.
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
        // this.showAddContactDialog()
    }
    /**
    */
    onEnter(value) {
        if (this.opened) {
            this.clickClose('close', null);
        }
    }

    onClickSaveEntity(event: Event) {
        if (event) {
            event.stopPropagation();
        }
        // Check if the user is an admin and in edit mode with a changed entity type
        if (this._isAdminUser && this.dialogOpenOptions.openType === EntityDialogType.EditEntity && this.entityTypeCurrent.id !== this.entityTypeDefault.id) {
            this._alertWindow.warn(StringLiteralsPipe.translate('crm.entity_type_has_been_changed'),
                [StringLiteralsPipe.translate('crm.entity_type_changed_warning')],
                StringLiteralsPipe.translate('general.publish'),
                StringLiteralsPipe.translate('general.go_back')
            ).pipe(
                take(1),
            ).subscribe((result: boolean) => {
                if (result) {
                    // If "Publish" is clicked, proceed with the save logic                    
                    this._processSave(true);
                } else {
                    // If "Go Back" is clicked, simply return and do nothing
                    return;
                }
            });
        } else {
            // If no type change or not admin/edit mode, proceed with the save logic
            this._processSave(false);
        }
    }

    trackByFn(index) {
        return index;
    }

    private _actionMessageHandler(action) {
        if (!action.prefix) {
            action.prefix = '';
        }
        if (action.prefix === this.id) {
            // only entitydialog which equals instaceId;
            // if (this.opened && this.dialogOpenOptions.instanceId && this.id === this.dialogOpenOptions.instanceId) {
            const entityBack = new EntityBack();
            let toastMsg: string;
            let lastAction: string;
            if (this.dialogOpenOptions && this.dialogOpenOptions.openType === EntityDialogType.NewEntity) {
                lastAction = CREATE_ENTITY_ALL_SUCCESS;
            } else {
                lastAction = EDIT_ENTITY_ALL_SUCCESS;
            }
            if (action.type === CREATE_ENTITY_SUCCESS || action.type === EDIT_ENTITY_SUCCESS) {
                this.isProgressing = false;
                if (this.dialogOpenOptions && this.dialogOpenOptions.openType === EntityDialogType.NewEntity) {
                    this.opened = false;
                    this._setDialogCloseForPlugin();
                    toastMsg = 'Entity ' + action.payload.name + ' successfully created.';
                    this._infoToast.message = toastMsg;
                    this._infoToast.style = NotificationStyles.Success;
                    this._setNewEntityForAddIn(entityBack);
                } else {
                    this._openDynamicComponentService.feedbackSubject$.next({
                        type: DialogAction.CloseDialog,
                        payload: action.payload.id
                    });
                    toastMsg = 'Entity ' + action.payload.name + ' successfully updated.';
                    this._infoToast.message = toastMsg;
                    this._infoToast.style = NotificationStyles.Info;
                }
                if (this.entity) {
                    this.entity.id = action.payload.id;
                }
                if (this.entity.type.id === EntityType.TEAM.id) {
                    this._store.dispatch({
                        type: TeamsActionTypes.INITIALIZE
                    });
                }

                if (this._configurationData && !this._configurationData.isDefaultConfig) {
                    // not default template
                    this._hasEntry = true;
                    this._preSaveNote(false);
                } else {
                    this._hasEntry = false;
                    this._handleEntitySuccess();
                }
            } else if (action.type === CREATE_ENTITY_FAILURE || action.type === EDIT_ENTITY_FAILURE) {
                this.isProgressing = false;
                let errMessage = action.payload.toString();
                if (errMessage && errMessage.indexOf('ERR_DUPLICATE_ENTITY') !== -1) {
                    errMessage = errMessage.substring(errMessage.indexOf('An Entity with'),
                        errMessage.indexOf('(TransactionID'));
                } else {
                    errMessage = 'Save Entity error';
                }
                const subscription = this._alertWindow.error('Alert', [errMessage], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                    .subscribe((result: boolean) => {
                        subscription.unsubscribe();
                    });
                this._openDynamicComponentService.feedbackSubject$.next(DialogAction.Error);
            }
            // three case: only
            this._isEntitySuccess = false;
            if (action.type) {
                if (!this._hasEntry && (action.type === CREATE_ENTITY_SUCCESS || action.type === EDIT_ENTITY_SUCCESS)) {
                    this._isEntitySuccess = true;
                    this.isProgressing = false;
                }
                if (this._hasEntry && action.type === CREATE_NOTE_SUCCESS) {
                    this.isProgressing = false;
                    this._isEntitySuccess = true;
                } else if (this._hasEntry && action.type === CREATE_NOTE_FAILURE) {
                    this.isProgressing = false;
                    this._isEntitySuccess = false;
                }
                if (this._isEntitySuccess && this.dialogOpenOptions) {
                    if (this.dialogOpenOptions.openType === EntityDialogType.NewEntity) {
                        this._store.dispatch(
                            new CreateEntityAllSuccess(
                                {
                                    type: lastAction,
                                    payload: lastAction,
                                },
                                'prefix',
                                this.dialogOpenOptions.instanceId
                            )
                        );
                    } else {
                        this._store.dispatch(
                            new EditEntityAllSuccess(
                                {
                                    type: lastAction,
                                    payload: lastAction,
                                },
                                'prefix',
                                this.dialogOpenOptions.instanceId
                            )
                        );
                    }
                }

                if (action.type === lastAction) {
                    setTimeout(() => {
                        this._toast.notify(this._infoToast);
                    }, AppConfig.subPageTransitionDuration);
                    if (!this._isIncludeSaveActions) {
                        this._feedbackForOnTheFly();
                        this._cleanAndClose();
                    }
                }
            }
            if (action.type === CREATE_RELATIONSHIP_SUCCESS || action.type === CREATE_RELATIONSHIP_FAILURE) {
                if (this._isIncludeSaveActions) {
                    this._feedbackForOnTheFly();
                    this._cleanAndClose();
                }
                this.isProgressing = false;
                this._handleEntitySuccess();
            }
        }
    }

    /**
     *
     *   1.new a Set for all appendControl(Prevent duplicate value)
     *   2.forEach this Set then  filter entities which can be added to dualist-right
     *   3.Records are appended entities collections then find  removeItem List.
     *   4.move  privacyList(direction=right) indexof removeItem to 'left'.
     * */
    private _appendEntitytoMemberShip(res) {
        const _selectUser = new Set();
        this._templateValueSet = res;
        for (const controlValue in this._templateValueSet) {
            const control = this._templateValueSet[controlValue];
            if (control.saveActions && control.saveActions.appendToMembershipList && this._isAccessList) {
                const values = control.value.split(',');
                if (values.length > 0) {
                    // tslint:disable-next-line: forin
                    for (const i in values) {
                        _selectUser.add(values[i]);
                    }
                }
            }
        }
        const privacyList = this.duallistConfig.dataSource;
        if (_selectUser) {
            Array.from(_selectUser).forEach(element => {
                if (privacyList.filter(item => item.data.id === element).length > 0) {
                    const index = privacyList.findIndex(item => item.data.id === element);
                    if (index !== -1 && privacyList.filter(item => item.data.id === element).length > 0) {
                        if (privacyList[index].direction === 'left') {
                            privacyList[index].direction = 'right';
                            this._addToMemberShip.push(privacyList[index].data.id);
                        }
                    }
                }
            });
        }
        const rightItem = privacyList ? privacyList.filter(item => item.direction === 'right') : [];
        const removeItem = [];
        this._addToMemberShip.forEach(item => {
            if (_selectUser.size > 0 && Array.from(_selectUser).indexOf(item) === -1) {
                removeItem.push(item);
            }
        });
        rightItem.forEach(item => {
            if (removeItem.length > 0 && removeItem.indexOf(item.data.id) !== -1) {
                item.direction = 'left';
            }
        });
    }

    /**
    * After finished create /edit entity /create relationship ,should clean data and close dialog.
    */
    private _cleanAndClose() {
        this._clearData();
        this.opened = false;
        this._setDialogCloseForPlugin();
        this._openDynamicComponentService.feedbackSubject$.next(DialogAction.CloseDialog);
    }

    /**
     * Due to we need to get create relationship status, but for on the fly ,we suppport multi  entity dialog
     * so we need to set prefix id for action of create relationship.
     * @param relationshipArray
     */
    private _createRelationship(relationshipArray) {
        this._relationshipService.createRelationships(relationshipArray)
            .pipe(
                take(1),
                catchError((error) => {
                    this._store.dispatch(
                        new CreateRelationShipFailed(
                            {
                                type: CREATE_RELATIONSHIP_FAILURE,
                                payload: CREATE_RELATIONSHIP_FAILURE
                            },
                            'prefix',
                            this.dialogOpenOptions ? this.dialogOpenOptions.instanceId : ''
                        )
                    );
                    return observableOf(null);
                }),
            )
            .subscribe(res => {
                return this._store.dispatch(
                    new CreateRelationShipSuccess(
                        {
                            type: CREATE_RELATIONSHIP_SUCCESS,
                            payload: CREATE_RELATIONSHIP_SUCCESS
                        },
                        'prefix',
                        this.dialogOpenOptions ? this.dialogOpenOptions.instanceId : ''
                    )
                );
            });
    }

    /**
     * If this dialog is opened for on the fly ,we need to feedback value for last page.
     */
    private _feedbackForOnTheFly() {
        if (this.dialogOpenOptions) {
            const entityBack = new EntityBack();
            entityBack.controlId = this.dialogOpenOptions.controlId;
            entityBack.entityId = this.entity.id;
            entityBack.searchValue = this.dialogOpenOptions.searchValue;
            entityBack.isCreateValidEntity = this.dialogOpenOptions.isCreateValidEntity;
            entityBack.currentId = this.dialogOpenOptions.instanceId;
            this._openDynamicComponentService.feedbackSubject$.next(entityBack);
            this._setNewEntityForAddIn(entityBack);
        }
    }

    private _initDefaultSubscribe() {
        this._destroySubscriptions.push(
            this._store.pipe(select(lastCustomActionSelector),
            ).subscribe(action => this._actionMessageHandler(action)),
            this._store.pipe(select(availableEntityTypeSelector),
                filter(res => res != null)
                // due to not sure why  wrote take(2). Temporary annotation after smoking test past it will be removed
                // take(2)
            ).subscribe(res => this._takeEntityType(res)),
        );
    }

    private _initMembers() {
        if (this.duallistConfig && this.duallistConfig.dataSource) {
            this.duallistConfig.dataSource.forEach(item => {
                if (this.entity.topicMembers && this.entity.topicMembers.filter(data => data.id === item.data.id).length > 0) {
                    item.direction = 'right';
                }
            });
            this._startDuallistConfig = _lodash.cloneDeep(this.duallistConfig);
        }
    }

    private _initOfficeAddIn(dialogOpenOptions: EntityDialogOpenOptions) {
        this.isOfficeAddinMode = dialogOpenOptions.isOfficeAddinMode;
        if (this.isOfficeAddinMode && this._el.querySelector('.entity-dialog')) {
            this._renderer.addClass(this._el.querySelector('.entity-dialog'), 'entity_dialog_container');
        }
    }

    private _initSubscribe() {
        if (this.dialogOpenOptions.openType === EntityDialogType.NewEntity) {
            if (!this.dialogOpenOptions.entityType) {
                this._destroySubscriptions.push(
                    this._store.pipe(select(defaultEntityTypeSelector),
                        filter(res => res != null),
                    ).subscribe(res => this._takeDefaultEntityType(res))
                );
            }
            this._destroySubscriptions.push(
                this._noteTemplatePageViewModel.entityTemplateConfiguration(this.dialogOpenOptions.instanceId.toString())
                    .pipe(
                        filter(res => res != null && res.contains != null),
                    ).subscribe(res => {
                        this._processNoteTemplateConfiguration(res);
                    })
            );
        }
        this._destroySubscriptions.push(
            this._noteTemplatePageViewModel.templateValueSet(this.dialogOpenOptions.instanceId)
                .subscribe(res => {
                    this._appendEntitytoMemberShip(res);
                }),
            this._messageService.messageSubject$.subscribe(action => this._onMessageAction(action)),
        );
    }

    /**
     * recive server notification and reopen entity dialog.
     * @param action
     */
    private _onMessageAction(action) {
        if (action.type === MessageType.ENTITY_TEMPLATE && action.payload.id === this.entityTypeCurrent.id && this.opened) {
            this.isNeedReload = true;
            this._notifyAction = action;
        }
    }

    onClickReload() {
        const entityDialogOpenOptions = _lodash.cloneDeep(this.dialogOpenOptions);
        if (this.dialogOpenOptions.openType === EntityDialogType.EditEntity) {
            entityDialogOpenOptions.entityId = this._entityId;
        }
        this._previousEntityType = _lodash.cloneDeep(this.entityTypeCurrent);
        this.opened = false;
        this._setDialogCloseForPlugin();
        this._clearData();
        this._notifyAction = null;
        this._entityDialogService.dialogOpen$.next(entityDialogOpenOptions);
    }

    /**
     * user create entity on the fly .should be judge entityType.
     * @param dialogOpenOptions
     */
    private _onTheFlyEntityType(dialogOpenOptions) {
        // if entity control has entityType use this entityType for config
        if (dialogOpenOptions.entityType) {
            this.entityTypes = [];
            dialogOpenOptions.entityType.forEach(element => {
                this.entityTypesResource.forEach(item => {
                    if (item.id === element) {
                        this.entityTypes.push(item);
                    }
                });
            });
            if (this.entityTypes.length > 0) {
                this.entityTypeCurrent = this.entityTypes[0];
                this._noteTypeChanged(this.entityTypeCurrent, 0);
            } else {
                this.entityTypeCurrent = null;
            }
        }
        if (!this.entityTypeCurrent) {
            this.entityTypeCurrent = { name: businessConstants.EntityTypesName.corporate, id: businessConstants.EntityTypes.Corporate_Id };
            this._noteTypeChanged(this.entityTypeCurrent, 0);
        }
    }

    private _processNoteTemplateConfiguration(config: any) {
        this._configurationData = config;
        this._noteTypeId = config.noteType.id;
        const target = JSON.parse(JSON.stringify(config)); // a way of deep copy

        const windowWidth = window.innerWidth - 120;
        if (config.width * this._widthFactor > windowWidth) {
            this._widthFactor = windowWidth / config.width;
        }
        this.dialogWidth = Math.floor(target.width * this._widthFactor) + 80;

        this._noteTemplatePageViewModel.cleanTemplateValueSet(this.dialogOpenOptions?.instanceId);
        this.valueChangeSubject = new ReplaySubject<any>(10);
        if (this.valueChangeSubscribtion && !this.valueChangeSubscribtion.closed) {
            this.valueChangeSubscribtion.unsubscribe();
        }
        switch (this.dialogOpenOptions?.openType) {
            case EntityDialogType.NewEntity:
                this._findFirstControl = false;
                if (this._firstOpen) {
                    this._firstOpen = false;
                    return Array.from(this._setStaticDefaultValueForCreate(this._processingDataFromJson(target.contains)));
                } else {
                    return Array.from(this._setStaticDefaultValueForNoteTypeSwitching(this._processingDataFromJson(target.contains)));
                }

            case EntityDialogType.EditEntity:
                this._findFirstControl = false;
                return Array.from(this._setStaticDefaultValueForEdit(this._processingDataFromJson(target.contains)));
        }
    }

    private _processingDataFromJson(config: any) {
        this._isIncludeSaveActions = false;
        this._tplConfig = [];
        this.isDisabled = this.isPrivate = this._hasAppendToMembership = false;
        if (this.dialogOpenOptions.openType === EntityDialogType.EditEntity) {
            this.isPrivate = !this.entity.isPublic;
        }
        if (this.dialogOpenOptions.openType === EntityDialogType.EditEntity && !this._isPublicToPrivateEntity) {
            this.isDisabled = true;
        }
        for (const row of config) {
            const newRow = row.concat();
            for (const ctrl of newRow) {
                // add prefixId for child control
                ctrl['prefixId'] = this.dialogOpenOptions.instanceId;
                if (ctrl.saveActions && ctrl.saveActions.appendToMembershipList) {
                    this.isPrivate = this.isDisabled = this._hasAppendToMembership = true;
                }
                ctrl.width = Math.floor(ctrl.width * this._widthFactor);
                if (ctrl.componentType === 'entity-input' && this._currentEntity != null) {
                    ctrl.staticDefaultValue = this._currentEntity.id;
                } else if (ctrl.componentType === 'ckeditor-input') {
                    ctrl.entryId = this._editingEntryId;
                    ctrl.noteTypeId = this._noteTypeId;
                } else if (this._entityName && (ctrl.componentType === 'name-input' || ctrl.componentType === 'shortname-input')) {
                    ctrl.staticDefaultValue = this._entityName;
                }
                ctrl.noteAction = NoteActions.createNote;
                if (ctrl.labelWidth > 0) {
                    ctrl.labelWidth = Math.floor(ctrl.labelWidth * this._widthFactor);
                    ctrl['controlWidth'] = ctrl.width - ctrl.labelWidth - 5;
                } else {
                    ctrl['controlWidth'] = ctrl.width - 5;
                }
                ctrl.viewContainer = this.viewContainer;
            }
            this._tplConfig.push(newRow);
        }
        this.entity.isPublic = !this.isPrivate;
        this._startEntity = _lodash.cloneDeep(this.entity);
        return this._tplConfig;
    }

    private _preSaveNote(draftFlag: boolean, auto: boolean = false) {
        let valueSet = _lodash.cloneDeep(this._templateValueSet);
        valueSet = this._templateService.processSaveActionsForWeb(valueSet, null, true, this._noteAction);
        this._saveNote(valueSet, false, false);
    }

    private _saveNote(valueSet, draftFlag: boolean, auto: boolean = false) {
        let noteBody = '';
        noteBody = this._templateService.createNoteBodyHtml(valueSet);
        const formData = {
            body: noteBody,
            keepdoc: false,
            entities: this.entity.id,
            source: AppConfig.userId,
            subject: this.entityTypeCurrent.name + ' Details',
        };

        const params = this._templateService.buildEntryTemplateParamsForWeb(valueSet, this._noteTypeId, null, null, true);
        this._templateValueSet = valueSet;
        this._entryService.publishNote('', params, formData).pipe(
            take(1),
        ).subscribe(
            (response) => {
                this._templateService.relationshipSaveAction(valueSet, this.entity);
                const relationshipArray = this._templateService.relationshipSaveAction(valueSet, this.entity);
                this._relationshipTreeService.relationshipTreeOperate$.next({
                    type: RelationshipTreeActions.EDIT_DETAILS,
                });

                if (relationshipArray && relationshipArray.length > 0) {
                    this._isIncludeSaveActions = true;
                    this._createRelationship(relationshipArray);
                } else {
                    // notify entity screen to update data
                    this._handleEntitySuccess();
                }
                this._store.dispatch(
                    new CreateNoteSuccess(
                        {
                            type: CREATE_NOTE_SUCCESS,
                            payload: CREATE_NOTE_SUCCESS
                        },
                        'prefix',
                        this.dialogOpenOptions ? this.dialogOpenOptions.instanceId : ''
                    )
                );
            },
            (error) => {
                this._store.dispatch(new CreateNoteSuccess(
                    {
                        type: CREATE_NOTE_SUCCESS,
                        payload: CREATE_NOTE_SUCCESS
                    },
                    'prefix',
                    this.dialogOpenOptions ? this.dialogOpenOptions.instanceId : ''
                ));
                this._handleEntitySuccess();
            });

    }

    private _setStaticDefaultValueForNoteTypeSwitching(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setStaticDefaultValueForNoteTypeSwitching(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['prefixId'] = this.dialogOpenOptions.instanceId;
                    if (!ctrl.isHidden && !this._findFirstControl && !this._specialCommonentTypes.includes(ctrl.componentType)) {
                        ctrl['isFirstControl'] = true;
                        this._findFirstControl = true;
                    }
                    // set ctrl statci default value when control type and adhocId matched
                    if (ctrl.controlID) {
                        let adhocId = '';
                        if (ctrl.adhocDefID) {
                            adhocId = ctrl.adhocDefID.toLowerCase();
                        } else {
                            adhocId = ctrl.controlID.toLowerCase();
                        }
                        if (this._previousTemplateValueSet && this._previousTemplateValueSet[adhocId]
                            && this._previousTemplateValueSet[adhocId][ctrl.componentType]) {
                            // disable entities field in create/edit sidenote mode when parent note is not editable
                            // disable entities field in edit note mode when one of sidenotes is note editable
                            if (ctrl.componentType === 'entity-input' && (this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote || this._noteAction === NoteActions.editNote)) {
                                ctrl.disabled = this._disableEntityField;
                            }

                            // only 1 entity in edit draft dialog and it's Uncategorized. hide it.
                            if (adhocId === 'entities' && this._previousTemplateValueSet[adhocId][ctrl.componentType].value.length === 1 &&
                                this._previousTemplateValueSet[adhocId][ctrl.componentType].value === businessConstants.entity.Uncategorized_Fixed_ID) {
                                ctrl.staticDefaultValue = [];
                            } else if (ctrl.componentType === 'tb-input') {
                                ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value.split('\r\n').join('\n');
                            } else if (ctrl.componentType === 'display-date' || ctrl.componentType === 'date-input') {
                                if (this._previousTemplateValueSet[adhocId][ctrl.componentType].value) {
                                    ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value.getTime();
                                }
                            } else if (ctrl.componentType === 'ckeditor-input') {
                                // Already has ctrl.NotebodyDetails. Add below properties for Notebody/EntryForm usage.
                                ctrl.entryId = this._editingEntryId;
                                ctrl.noteTypeId = this._noteTypeId;
                                // check isPlugInEditNoteMode&&editnote logic in notebody

                                // if last note type is EntryForm, clear note body in Note dialog;
                                // 1.if current note type is EntryForm , the note body class will load content as its own logic;
                                // 2.if current note type is non-EntryForm, the note body class use staticDefaultValue directly.
                                if (this._isPreNoteEntryForm) {
                                    ctrl.staticDefaultValue = '';
                                } else {
                                    // or else,  kept the note body content.
                                    ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                                }

                                // keep current status.
                                if (ctrl.notebodyDetails) {
                                    this._isPreNoteEntryForm = ctrl.notebodyDetails.prepopulateTemplateChecked;
                                }
                            } else {
                                ctrl.staticDefaultValue = this._previousTemplateValueSet[adhocId][ctrl.componentType].value;
                            }
                        }
                    }
                }
            }
        }
        return config;
    }

    private _setStaticDefaultValueForCreate(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setStaticDefaultValueForCreate(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = this._noteAction;
                    ctrl['prefixId'] = this.dialogOpenOptions.instanceId;
                    // Hide this code to fix TAM-34742
                    // if (!ctrl.isHidden && !this._findFirstControl && !this._specialCommonentTypes.includes(ctrl.componentType)) {
                    //     ctrl['isFirstControl'] = true;
                    //     this._findFirstControl = true;
                    // }
                }
            }
        }
        return config;
    }

    private _setStaticDefaultValueForEdit(config: any) {
        for (const row of config) {
            for (const ctrl of row) {
                if (ctrl.componentType === 'group' || ctrl.componentType === 'virtualgroup') {
                    ctrl.contains = Array.from(this._setStaticDefaultValueForEdit(ctrl.contains));
                    ctrl['widthFactor'] = this._widthFactor;
                } else {
                    // set ctrl note action first
                    ctrl.noteAction = NoteActions.editNote;
                    ctrl['prefixId'] = this.dialogOpenOptions.instanceId;
                    ctrl['entityAction'] = EntityActions.editEntity;
                    if (!ctrl.isHidden && !this._findFirstControl && !this._specialCommonentTypes.includes(ctrl.componentType)) {
                        ctrl['isFirstControl'] = true;
                        this._findFirstControl = true;
                    }
                    // set ctrl statci default value when control type and adhocId matched
                    if (ctrl.controlID) {
                        let adhocId = '';
                        if (ctrl.adhocDefID) {
                            adhocId = ctrl.adhocDefID.toLowerCase();
                        } else {
                            adhocId = ctrl.controlID.toLowerCase();
                        }
                        ctrl.entityId = this.entity.id;
                        if (ctrl.componentType === 'shortname-input') {
                            ctrl.staticDefaultValue = this.entity.shortName;
                        } else if (ctrl.componentType === 'name-input') {
                            ctrl.staticDefaultValue = this.entity.name;
                        } else if (ctrl.componentType === 'mdl-input' && ctrl.mdlProvider && ctrl.mdlProvider.fieldname === 'ENTITIES') {
                            ctrl.mdlProvider.value = this.entity.name;
                        } else {
                            if (this.entity.adhocs && this.entity.adhocs.size > 0) {
                                this.entity.adhocs.forEach(adhoc => {
                                    if (adhoc.id.toString() === ctrl.adhocDefID) {
                                        if (ctrl.componentType === 'met-input' || ctrl.componentType === 'med-input') {
                                            const valueArr = JSON.parse(adhoc.value);
                                            const valueNames = [];
                                            valueArr.forEach(item => {
                                                valueNames.push(item.id);
                                            });
                                            ctrl.staticDefaultValue = valueNames.join(',');
                                        } else if (ctrl.componentType === 'ed-input') {
                                            const obj = JSON.parse(adhoc.value);
                                            ctrl.staticDefaultValue = obj.id;
                                        } else if (ctrl.componentType === 'displaydate-input' || ctrl.componentType === 'date-input' && adhoc.value.includes('/')) {
                                            ctrl.staticDefaultValue = Date.parse(adhoc.value);
                                        } else {
                                            ctrl.staticDefaultValue = adhoc.value;
                                        }
                                    }
                                });
                            }
                        }

                    }
                }
            }
        }
        return config;
    }

    public handleFilter(value) {
        if (value === '') {
            this.entityTypes = this.entityTypesResource;
        } else {
            this.entityTypes = this.entityTypesResource.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        }
    }

    public selectionChange(value: any): void {
        this._accumulateTemplateValueSetChanges(); // save the previous template when switching note types
        this._noteTypeChanged(value, 0);
        this.noEntityType = false;
        this.isNeedReload = false;
    }
    private _accumulateTemplateValueSetChanges() {
        // this._previousTemplateValueSet = {};
        // tslint:disable-next-line: forin
        for (const controlId in this._templateValueSet) {
            const ctrl = this._templateValueSet[controlId];
            // tslint:disable-next-line: prefer-const
            let adhocId, adhocDefId = ctrl.adhocDefId.toString();
            if (adhocDefId.indexOf('x-') > -1) {
                adhocId = adhocDefId.slice(2).toLowerCase();
            } else {
                adhocId = adhocDefId.toLowerCase();
            }
            if (this._previousTemplateValueSet[adhocId] == null) {
                this._previousTemplateValueSet[adhocId] = {};
            }
            this._previousTemplateValueSet[adhocId][ctrl.componentType] = this._templateValueSet[controlId];
        }
    }

    private _clearData() {
        this.entityTypeDisabled = false;
        this._configurationData = '';
        this._tplConfig = [];
        // this.entityTypeCurrent = this.entityTypeDefault = null;
        this._templateDialogService.changeValueStatus = false;
        this._previousTemplateValueSet = {};
        this.dialogWidth = null;
        this.isPrivate = false;
        this.aliasArray = null;
        this.weblinkName = '';
        this.weblinkUrl = '';
        this.name = '';
        this.position = '';
        this.age = '';
        this.entity = null;
        this._noteTypeId = '';
        this._addToMemberShip = [];
        this._firstOpen = true;
        this.isShow = false;
        // message and configuration data should be clear
        this._entityViewModel.clearEntityTemplate(this.dialogOpenOptions.instanceId);
        this._noteTemplatePageViewModel.cleanTemplateMsg(this.dialogOpenOptions.instanceId);
        this.dialogOpenOptions = null;
        this._hasEntry = false;
        this._startEntity = null;
        this.isNeedReload = false;
    }

    // notify entity screen to update data
    private _handleEntitySuccess() {
        this._entityDialogService.entityEditStatus$.next({
            type: EntityEditStatusActionType.EDIT_ENTITY_CREATE_ENTRY_ALL_SUCCESS
        });
    }

    private _initData() {
        this.noEntityType = false;
        this.entityTypeDisabled = false;
        this.entityTypes = null;
        // this._initTabs('Corporate');
        this.entityTypeCurrent = new EntityType();
        this.entityTypes = this.entityTypesResource;
        this._tplConfig = [];
        this.opened = true;
        this._noteAction = NoteActions.createNote;
        this.dialogWidth = 684;
        this.entity = new Entity();
        this.entity.webAddress = new Array<AddressDetail>();
        this.entity.webAddress[0] = new AddressDetail();
        this.entity.webAddress[0].name = 'Primary';
        this.isPrivate = false;
        this.entity.detail = new CorporateDetail();
        this.entity.detail.officers = new Array<CorpOfficer>();
        this.entity.webLinks = new Array<WebLink>();
        this.entity.isPublic = true;
        this.entity.aliases = new Array<string>();
        this._startEntity = new Entity();
    }

    private _initTabs(type: string, openTab: number) {
        let menuItems = [];
        if (this.entity) {
            if (type !== 'Corporate') {
                this.entity.detail = new CorporateDetail();
                this.entity.detail.officers = new Array<CorpOfficer>();
            }
        }
        if (type === 'Corporate') {
            this.tabNumber = 4;
            menuItems = [
                new TabItem('Overview'),
                new TabItem('Privacy'),
                new TabItem('Corporate Details'),
                new TabItem('Extra Information'),
            ];
            //  menuItems.splice(2, 0, new TabItem('Corporate Details'));
        } else if (type === 'Team') {
            this.tabNumber = 3;
            menuItems = [
                new TabItem('Overview'),
                new TabItem('Team Management'),
                new TabItem('Extra Information'),
            ];
            this.isPrivate = false;
        } else {
            this.tabNumber = 3;
            menuItems = [
                new TabItem('Overview'),
                new TabItem('Privacy'),
                new TabItem('Extra Information'),
            ];
        }
        this.tabsOptions = new TabOptions(menuItems, openTab, true);
    }

    private _initPrivacy() {
        this.duallistConfig = new DualListConfig();
        this.duallistConfig.titles = [businessConstants.dualList.userNotAllowedAccessTitle, businessConstants.dualList.userAllowedAccessTitle];
        this.duallistConfig.dataTextField = 'name';
        this.duallistConfig.dataValueField = 'id';
        this.duallistConfig.dataSource = null;
    }

    /**
     * add TeamConfig
     */
    private _initTeamsConfig() {
        let accessListSelector: any = null;
        this.dualListTeamConfig = new DualListConfig();
        this.dualListTeamConfig.disabled = !this._isIncludeTeam;
        this.dualListTeamConfig.placeholderText = 'Filter';
        this.dualListTeamConfig.titles = [businessConstants.dualList.userNotAllowedAccessTitle, businessConstants.dualList.userAllowedAccessTitle];
        this.dualListTeamConfig.dataTextField = 'name';
        this.dualListTeamConfig.dataValueField = 'id';
        this.dualListTeamConfig.dataSource = null;
        accessListSelector = createSelector(
            (state: AppState) => state.users,
            (allUser) => {
                if (allUser.length === 0) {
                    return [];
                }
                const users = allUser.map(item => {
                    if (item.id === this.currentUser.id && this.dialogOpenOptions.openType === EntityDialogType.NewEntity) {
                        return new DualListItem(item, 'right');
                    } else {
                        return new DualListItem(item);
                    }
                });
                return users;
            }
        );
        this._destroySubscriptions.push(
            this._store.pipe(
                select(accessListSelector),
                filter((list: any) => list.length > 0),
            ).subscribe(list => {
                this.dualListTeamConfig.dataSource = list;
            })
        );
    }

    /**
     * add UserAndTeamConfig
     */
    private _initTeamsAndUsersConfig() {
        let accessListSelector: any = null;
        this.dualListUserAndTeamConfig = new DualListConfig();
        this.dualListUserAndTeamConfig.titles = [businessConstants.dualList.userNotAllowedAccessTitle, businessConstants.dualList.userAllowedAccessTitle];
        this.dualListUserAndTeamConfig.dataTextField = 'name';
        this.dualListUserAndTeamConfig.dataValueField = 'id';
        this.dualListUserAndTeamConfig.dataSource = [];
        this.dualListUserAndTeamConfig.disabled = !this._isAccessList;
        this.dualListUserAndTeamConfig.placeholderText = 'Search User or Teams';
        accessListSelector = createSelector(
            (state: AppState) => state.users || [],
            (state: AppState) => state.teams || [],
            (allUser, allTeam) => {
                if (allUser.length === 0 || allTeam.length === 0) {
                    return [];
                }
                const users = allUser.map(item => {
                    if (item.id === this.currentUser.id && this.dialogOpenOptions?.openType === EntityDialogType.NewEntity) {
                        return new DualListItem(item, 'right');
                    } else {
                        return new DualListItem(item);
                    }
                });
                const teams = allTeam.map(item => {
                    return new DualListItem(Object.assign({ type: 'team' }, item));
                });
                return users.concat(teams);
            }
        );
        this._destroySubscriptions.push(
            this._store.pipe(
                select(accessListSelector),
                filter((list: any) => list.length > 0),
            ).subscribe(list => {
                this.dualListUserAndTeamConfig.dataSource = list;
            })
        );
    }
    private _noteTypeChanged(value, openTab) {
        if (value.name === 'Team') {
            this._initTeamsConfig();
            this.duallistConfig = this.dualListTeamConfig;
        } else {
            this._initTeamsAndUsersConfig();
            this.duallistConfig = this.dualListUserAndTeamConfig;
        }
        this._startDuallistConfig = _lodash.cloneDeep(this.duallistConfig);
        this._initTabs(value.name, openTab);
        this.isShow = true;
        const prefixId = this.dialogOpenOptions?.instanceId;
        if (prefixId !== null) {
            this._noteTemplatePageViewModel.getEntityTemplateConfiguration(value.id, prefixId);
        }
    }

    private _processSave(isAdminEditEntityType = false) {
        const valueSet = _lodash.cloneDeep(this._templateValueSet);
        let updateTopicMember = false;
        this.entity.type = new EntityType();
        this.entity.type = this.entityTypeCurrent;
        this.entity.isPublic = !this.isPrivate;
        this.entity.isAdminEditEntityType = isAdminEditEntityType;
        this._formatAliases();
        if (this.dualListInst) {
            this.entity.topicMembers = this.dualListInst.getSelectedItem(true).join(',');
        }
        this._processAddress();
        if (this._validateForm(valueSet)) {
            this.isProgressing = true;
            for (const key in valueSet) {
                const ctrl = valueSet[key];
                if (ctrl.componentType === ComponentTypes.name) {
                    delete this._templateValueSet[key];
                } else if (ctrl.componentType === ComponentTypes.shortname) {
                    delete this._templateValueSet[key];
                }
            }
            if (this.entity.topicMembers) {
                if ((this.entity.type.name !== 'Team' && this.entity.isPublic === false && this._isAccessList)
                    || (this.entity.type.name === 'Team' && this._isIncludeTeam)) {
                    updateTopicMember = true;
                }
            }
            if (this.dialogOpenOptions.openType === EntityDialogType.NewEntity) {
                this._entityViewModel.createEntity(this.entity, updateTopicMember, this.dialogOpenOptions.instanceId);
            } else if (this.dialogOpenOptions.openType === EntityDialogType.EditEntity) {
                this.entity.id = this._entityId;
                this._entityViewModel.editEntity(this.entity, updateTopicMember, this.dialogOpenOptions.instanceId);
            }
        }
    }

    private _takeEntityType(res: any) {
        this.entityTypesResource = res.filter(item => this._isIncludeTeam ? item : item.name !== 'Team');
        ArrayHelperService.sort(this.entityTypesResource, 'name');
        this.entityTypes = this.entityTypesResource.slice();

    }

    /**
     * only for web plugin
     * the value of 'hidden-note-dialog' should be 20 after click save/close/save draft button
     */
    private _setDialogCloseForPlugin() {
        this.isDialogClosedForPlugin = 20;
    }

    private _takeDefaultEntityType(res: any) {
        this.entityTypeDefault = this.entityTypeCurrent = res;
        if (this._previousEntityType) {
            this.entityTypeDefault = this.entityTypeCurrent = _lodash.cloneDeep(this._previousEntityType);
            this._previousEntityType = null;
        }
        this._noteTypeChanged(this.entityTypeDefault, 0);
    }

    // Validation
    private _validateForm(valueSet) {
        let subscription;
        const emptyFields = this._templateService.checkRequiredFields(valueSet);
        if (emptyFields.length > 0) {
            let msg = '';
            const msgArr = [];
            for (let emptyField of emptyFields) {
                emptyField = emptyField.trim();
                if (emptyField.lastIndexOf(':') === emptyField.length - 1) {
                    emptyField = emptyField.substring(0, emptyField.length - 1);
                }
                msgArr.push(emptyField);
                msg = msgArr.join(',');
            }
            subscription = this._alertWindow.error('Required data', ['Please enter the information for the required fields:', msg], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });

            return false;
        }

        if (this.isPrivate && !this.entity.topicMembers) {
            subscription = this._alertWindow.error('Alert', ['AccessList of private entity must have at least one member!'], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
            return false;
        }

        if (!this.entity.topicMembers && this.entityTypeCurrent.name === 'Team') {
            subscription = this._alertWindow.error('Alert', ['Team must have at least one memeber!'], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue).subscribe((result: boolean) => {
                subscription.unsubscribe();
            });
            return false;
        }
        // tslint:disable-next-line: forin
        for (const key in valueSet) {
            const ctrl = valueSet[key];
            if (ctrl.componentType === ComponentTypes.name) {
                this.entity.name = ctrl.value;
            } else if (ctrl.componentType === ComponentTypes.shortname) {
                this.entity.shortName = ctrl.value;
            }
        }

        // shortname cannot contain comma
        if (this.entity.shortName.includes(',')) {
            subscription = this._alertWindow.error('Alert', ['Tamale does not allow commas in entity shortnames.', 'Please remove it and try again'], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
            return false;
        }

        // // shortname's length <=128
        if (this.entity.shortName.length > 128) {
            subscription = this._alertWindow.error('Alert', ['Shortname can not have more than 128 characters'], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
            return false;
        }

        // aliases's length <=128
        const aliasList = this.aliasArray;
        if (aliasList) {
            for (let ii = 0; ii < aliasList.length; ++ii) {
                if (aliasList[ii].length > 128) {
                    subscription = this._alertWindow.error('Alert', ['Alias name can not have more than 128 characters'], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                        .subscribe((result: boolean) => {
                            subscription.unsubscribe();
                        });
                }
            }
        }
        // when user has appendtoMembership control, he need to check both publicToPrivate conversion Update Access List credential.
        if (this._hasAppendToMembership && (!this._isAccessList || !this._isPublicToPrivateEntity)) {
            // tslint:disable-next-line: max-line-length
            subscription = this._alertWindow.error('Alert', ['Because you\'ve configured entity template with save action - Append selected entities to privacy list, so make sure you have both Public to Private Entity credential and Update Access List Credential'], this.dialogOpenOptions.eventKey, this.dialogOpenOptions.eventValue)
                .subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
            return false;
        }
        return true;
    }

    // validate the alias item length
    private _validateAliasLength(control: UntypedFormControl) {
        if (control.value.length > 128) {
            return {
                'errormessage': true
            };
        }
        return null;
    }

    // the format of aliasArray may be changed after retrieving from server side for edit.
    private _formatAliases() {
        this.entity.aliases = [];
        if (this.aliasArray) {
            for (let i = 0; i < this.aliasArray.length; i++) {
                if (this.aliasArray[i]) {
                    if (this.aliasArray[i]['value']) {
                        this.entity.aliases.push(this.aliasArray[i]['value']);
                    } else {
                        this.entity.aliases.push(this.aliasArray[i]);
                    }
                }
            }
        }
    }

    /**
     *filter entity webAddress isn't null.
     *
     * @private
     * @memberof EntityDialogComponent
     */
    private _processAddress() {
        if (this.entity.webAddress && this.entity.webAddress.length > 0) {
            this.entity.webAddress = this.entity.webAddress.filter(item => item.country || item.state || item.street || item.street2 || item.zip || item.city || item.name === EntityAddressType.Primary);
        }
        this.entity.webAddress.forEach((item: AddressDetail, index) => {
            if (index > 0) {
                item.name = EntityAddressType.Other + index;
            }
        });
    }

    /**
    * close the dialog box only when the button of 'publish' is clicked on the first dialog for add-in.
    */
    private _setNewEntityForAddIn(entityBack: EntityBack) {
        if (AddInUtilities.isOfficeEnvironment() && entityBack.currentId === '1') {
            Office.context.ui.messageParent(JSON.stringify(entityBack));
        }
    }
}
